import React, { useState } from 'react';
import Layout from '../components/Layout';
import { X } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

var galleryImages = [
  'https://static.wixstatic.com/media/4a2ebb_aa8bb1d156234cd2aa6d3e0059e66636~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_085b2663fbfd452a85af4f373e594048~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_731ea530a7d64bb48cc867b5fe0f4521~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_8ad4193ec7cc49f6b8a8adfa3acf1f03~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_193a4ecdb83649ea937de5139d975634~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_e2b8f6dc8b0e4739a85ec82f5eb77571~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_c305de7e20974f95829d38e73e6c87c0~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_bbe192d915ab4051b00c97844a679f4f~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_ad8d84905ff6480f9cec5ad7e28f3093~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_09f8de3a89604019a7d5688a58ce7b6a~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_414c6eeeb9f64811a25e71cb64980f87~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_22bec196f1694d2a92a7717b34e99416~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_d8310ccbe8244c298f95f15fc0944ad6~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_582f4f7b19724444aaf2a46c9c9009ae~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_63c1db06bef04d409b4cbdcfa96039d3~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_0cd998deb94d4e4fb7ad9206ddb85173~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_27774710af8848959a8de5139a9656e4~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_5b0f2d87f67e48a5bb15a60f1181385e~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_a4f7a5593e474cb994173078aafaa371~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_93e29245958d4ba0893e2264882284a4~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_d20f750d8e3d4639992f63a705478491~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_9aef511f4e6a4bcc820c560a858fd4e1~mv2.jpg',
  'https://static.wixstatic.com/media/4a2ebb_9c03723e63cc40969cea2240e4e06fe3~mv2.jpg',
];

function GalleryPage() {
  var { t } = useTranslation();
  var imageState = useState(null);
  var selectedImage = imageState[0];
  var setSelectedImage = imageState[1];

  return (
    <Layout>
      <SEO title={PAGE_SEO['gallery'].title} description={PAGE_SEO['gallery'].description} url="/gallery" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-[#d4af37] text-sm tracking-widest uppercase mb-4">{t('galleryPhotos')}</p>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">{t('galleryTitle')}</h1>
            <p className="text-xl text-neutral-400">
              {t('gallerySubtitle')}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {galleryImages.map(function(image, index) {
              return (
                <button
                  key={index}
                  onClick={function() { setSelectedImage(image); }}
                  className="aspect-square overflow-hidden rounded-lg group relative"
                >
                  <img
                    src={image}
                    alt={'Gallery image ' + (index + 1)}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    referrerPolicy="no-referrer"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300" />
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={function() { setSelectedImage(null); }}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#d4af37] transition-colors"
            onClick={function() { setSelectedImage(null); }}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage}
            alt="Gallery enlarged"
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            referrerPolicy="no-referrer"
            onClick={function(e) { e.stopPropagation(); }}
          />
        </div>
      )}
    </Layout>
  );
}

export default GalleryPage;
